import { ca } from '@cian/analytics';

export enum EFilterChoiceAction {
  Click = 'Click',
  ClickOnMoreAccuracyPopup = 'Click_on_MoreAccuracy_popup',
}

export interface ITrackFilterChoiceParams {
  label: string;
  action: EFilterChoiceAction;
}

export function trackFilterChoice({ label, action }: ITrackFilterChoiceParams) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'EstateCalculator',
    action,
    label,
  });
}

export const trackPreciseFiltersOpen = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'EstateCalculator',
    action: 'Click',
    label: 'PreciseFiltersOpen',
  });
};
